<mat-toolbar>
  <div class="start">
    <a routerLink="/" class="mr-2">
      <!-- prettier-ignore -->
      <svg data-testid="logo" class="logo" viewBox="0 0 262 110" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd" fill="#F60"><path d="M220.19 67.707l-10.232-8.944v-4.927h7.941c2.719 0 4.097-1.052 4.097-3.126s-1.378-3.125-4.097-3.125h-14.804v20.122h-5.247V42.696h19.873c7.959 0 9.63 4.358 9.63 8.014 0 6.475-5.199 7.834-9.56 7.834h-.521l11.032 9.163h-8.112zm-34.24-3.2c-2.956 2.446-7.3 3.739-12.561 3.739s-9.607-1.293-12.563-3.739c-2.784-2.303-4.256-5.521-4.256-9.305 0-3.786 1.472-7.004 4.256-9.306 2.956-2.446 7.3-3.739 12.563-3.739 5.261 0 9.605 1.293 12.561 3.739 2.784 2.302 4.257 5.52 4.257 9.306 0 3.784-1.473 7.002-4.257 9.305zm-42.245-14.935l-10.026 12.057V110h128.147V.435H133.679v54.167l9.988-11.906h5.285v25.011h-5.247V49.572zM97.312 67.707L87.08 58.763v-4.927h7.941c2.719 0 4.097-1.052 4.097-3.126s-1.378-3.125-4.097-3.125H80.217v20.122h-5.248V42.696h19.873c7.96 0 9.631 4.358 9.631 8.014 0 6.475-5.199 7.834-9.559 7.834h-.523l11.033 9.163h-8.112zm-48.161-6.978l2.612-4.812h3.967l-4.828-8.738-11.324 20.528h-6.052l14.328-25.011h6.132l14.33 25.011h-6.052l-3.867-6.978h-9.246zm68.97 6.978h-5.247V42.696h5.285l9.987 11.907V.435H0V110h128.146V61.629l-10.025-12.057v18.135z"></path><path d="M173.389 47.045c-7.285 0-11.463 2.973-11.463 8.157 0 5.183 4.178 8.156 11.463 8.156 7.283 0 11.462-2.973 11.462-8.156 0-5.184-4.179-8.157-11.462-8.157"></path></g></svg>
    </a>
    <div data-testid="start-slot" class="flex-align-center">
      <ng-content select="[slot='start']"></ng-content>
    </div>
  </div>

  <!-- ------------------------------------------------------------ Main nav  -->
  <div class="middle" #navItemWrapperEl>
    <div *ngIf="navItems">
      <div #shownNavItemsEl>
        <!-- ------------------------------------- Top-level "shown" items   -->
        <ng-container *ngFor="let section of navItems; index as i">
          <ng-container *ngIf="!section.items">
            <!-- ---------------- item w/no children   -->
            <button
              #navItemEl
              mat-button
              class="fw-normal px-3"
              [attr.data-index]="i"
              [routerLink]="section.route"
              data-testid="top-nav-item"
            >
              {{ section.label }}
            </button>
          </ng-container>
          <!-- -------------------- item w children   -->
          <ng-container *ngIf="section.items">
            <button
              #navItemEl
              mat-button
              class="fw-normal px-3"
              [attr.data-index]="i"
              [routerLink]="section.route ? section.route : []"
              [matMenuTriggerFor]="menu.subMenu"
            >
              {{ section.label }}
              <am-icon class="text-mono-5" name="chevron-down"></am-icon>
            </button>
            <!-- ------------ second-level  -->
            <am-app-nav-submenu
              #menu
              [items]="section.items"
            ></am-app-nav-submenu>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- ------------------------------------- Top-level "Hidden" items AKA the More menu  -->
    <div #hiddenNavItemsEl *ngIf="hiddenItems.length">
      <button mat-button [matMenuTriggerFor]="menu.subMenu">
        More
        <am-icon name="chevron-down"></am-icon>
      </button>
      <am-app-nav-submenu #menu [items]="hiddenItems"></am-app-nav-submenu>
    </div>

    <div data-testid="middle-slot" class="flex-align-center">
      <ng-content select="[slot='middle']"></ng-content>
    </div>
  </div>
  <!-- ------------------------------------- end Top-level "Hidden" items AKA the More menu  -->

  <div class="end">
    <div data-testid="end-slot" class="flex-align-center">
      <ng-content select="[slot='end']"></ng-content>
    </div>

    <!-- ------------------------------------- Theme switcher  -->
    <am-theme-toggle data-testid="theme-toggle"></am-theme-toggle>

    <!--  menu is last  -->
    <button mat-icon-button [matMenuTriggerFor]="menuRef" *ngIf="appMenu">
      <am-icon name="dots-vertical" data-testid="app-menu-trigger"></am-icon>
    </button>
    <mat-menu #menuRef="matMenu">
      <ng-container [ngTemplateOutlet]="appMenu"></ng-container>
    </mat-menu>
  </div>
</mat-toolbar>
